/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const featureHolderDetailConfig = {
  image:
    'https://www.washingtonpost.com/wp-apps/imrs.php?src=https://arc-anglerfish-washpost-prod-washpost.s3.amazonaws.com/public/4TBIVPDYMAI6XFENDFDS42BVEE.jpg&w=210',
  title: 'Merina',
  subtitle: 'Designer',
  buttons: [],
  approveButton: {
    key: 'updateKyc',
    title: 'Update Know Your Customer (KYC) Status',
    color: 'primary',
  },
  listItems: [
    {
      title: 'Full Name',
      subTitle: 'Merina',
      icon: 'https://static.vecteezy.com/system/resources/previews/007/033/146/original/profile-icon-login-head-icon-vector.jpg',
    },
    {
      title: 'Street Address',
      subTitle: 'vv street',
      icon: 'https://static.thenounproject.com/png/2481156-200.png',
    },
    {
      title: 'City',
      subTitle: 'Hebbal',
      icon: 'https://cdn-icons-png.flaticon.com/512/2451/2451474.png',
    },
    {
      title: 'Country',
      subTitle: 'Albania',
      icon: 'https://static.thenounproject.com/png/3437694-200.png',
    },
    {
      title: 'Email',
      subTitle: 'john@gmail.com',
      icon: 'https://cdn-icons-png.flaticon.com/512/666/666162.png',
    },
    {
      title: 'Telephone',
      subTitle: '+355 123-4567-890',
      icon: 'https://cdn-icons-png.flaticon.com/512/25/25377.png',
    },
    {
      title: 'Occupation',
      subTitle: 'Designer',
      icon: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTlmAWwBuuGoP-8_MpaVXGSCwijAOaWobKxiBBP2Cq8TY7d3PYFIIkPxn02jHbumjghL7I&usqp=CAU',
    },
  ],
  carouselItems: [
    {
      type: 'pdf',
      poster:
        'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/pdf-doc-illustration.png',
      src: 'https://s3.ap-south-1.amazonaws.com/io.klefki.kcoop/coop_evidence_v2.pdf',
      title: 'Select Id Proof',
    },
    {
      type: 'pdf',
      poster:
        'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/pdf-doc-illustration.png',
      src: 'https://s3.ap-south-1.amazonaws.com/io.klefki.kcoop/coop_evidence_v2.pdf',
      title: 'Select Id Proof',
    },
  ],
};
